var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagsAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8781 5.12635C18.086 4.76579 17.9603 4.3061 17.5974 4.09961C17.2345 3.89312 16.7718 4.01802 16.564 4.37857L12 12.2965L7.43603 4.37857C7.2282 4.01802 6.76553 3.89312 6.40264 4.09961C6.03974 4.3061 5.91403 4.76579 6.12186 5.12635L6.31002 5.45277L2.17106 11.634C1.71023 12.3222 2.23797 13.2378 3.06861 13.1911L10.529 12.7722L11.1274 13.8103L8.20882 18.8737C8.00099 19.2342 8.1267 19.6939 8.48959 19.9004C8.85249 20.1069 9.31516 19.982 9.52299 19.6214L12 15.3241L14.477 19.6214C14.6848 19.982 15.1475 20.1069 15.5104 19.9004C15.8733 19.6939 15.999 19.2342 15.7912 18.8737L12.8726 13.8103L13.471 12.7722L20.9314 13.1911C21.762 13.2378 22.2898 12.3222 21.8289 11.634L17.69 5.45277L17.8781 5.12635Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagsAlt);
export default __webpack_public_path__ + "static/media/flags-alt.716b8f330278efd27093fef40271a9c1.svg";
export { ForwardRef as ReactComponent };